<template>
  <v-dialog v-model="dialog" max-width="980px">
    <v-card>
      <v-card-title class="ma-3">
        <span>
          {{ $t("PurchasesDetail.supplierPrice.title") }}
        </span>
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="dialog = false"
            >
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <div class="ma-4">
        <v-data-table
          :headers="headers"
          :items="supplierPrices"
          :loading="loading"
          multi-sort
          class="elevation-0 px-6"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.supplier_name="{ item }">
            {{ item.supplier_name || '-' }}
          </template>
          <template v-slot:item.last_purchase_price="{ item }">
            {{ item.last_purchase_price !== '' ? $t("Global.money") + item.last_purchase_price : '-' }}
          </template>
          <template v-slot:item.quotation_price="{ item }">
            {{ item.quotation_price !== '' ? $t("Global.money") + item.quotation_price : '-' }}
          </template>
          <template v-slot:item.economy_price="{ item }">
            {{ item.economy_price !== '' ? $t("Global.money") + item.economy_price : '-' }}
          </template>
          <template v-slot:item.supply_price="{ item }">
            {{ item.supply_price != null ? $t("Global.money") + item.supply_price : '-' }}
          </template>
          <template v-slot:item.score="{ item }">
            {{ item.score || '-' }}
          </template>
        </v-data-table>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="
            dialog = false;
          "
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Purchases from "@/api/purchases";

export default {
  name: "SupplierPriceDialog",
  props: {
    value: Boolean,
    material: Object,
  },

  components: {
  },

  computed: {
    headers() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.supplierPrice.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
        },
        {
          text: i18n.t("PurchasesDetail.supplierPrice.last_purchase_price"),
          align: "start",
          sortable: false,
          value: "last_purchase_price",
        }
      ];
      if (this.$permission.permissionAllow("Quotations", "index")) {
        headers.push({
          text: i18n.t("PurchasesDetail.supplierPrice.quotation_price"),
          align: "start",
          sortable: false,
          value: "quotation_price",
        });
      }
      if (this.$permission.permissionAllow("Economies", "index")) {
        headers.push({
          text: i18n.t("PurchasesDetail.supplierPrice.economy_price"),
          align: "start",
          sortable: false,
          value: "economy_price",
        });
      }
      headers.push({
        text: i18n.t("PurchasesDetail.supplierPrice.supply_price"),
        align: "start",
        sortable: false,
        value: "supply_price",
      })
      if (this.$permission.permissionAllow("Suppliers", "supplierScore")) {
        headers.push({
          text: i18n.t("PurchasesDetail.supplierPrice.score"),
          align: "start",
          sortable: false,
          value: "score",
        })
      }
      return headers;
    },

    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    supplierPrices: [],
  }),

  methods: {
    getSupplierPurchasePricesFromAPI() {
      Purchases.getSupplierPurchasePrices(this.material.material_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.supplierPrices = response.data.supplier_prices;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    dialog: {
      handler() {
        this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getSupplierPurchasePricesFromAPI()
        }
      },
    },
  },
};
</script>
